export const InvitePresented = 'InvitePresented';
export const InviteAccepted = 'InviteAccepted';
export const InviteDeclined = 'InviteDeclined';
export const InviteClosed = 'InviteClosed';